























































































import {Component, Vue, Watch, Prop} from "vue-property-decorator"
import {namespace} from "vuex-class"
import {Route} from "vue-router"
import {TranslateResult} from "vue-i18n"
import TestAlert from "@/components/UI/TestAlert.vue";
import selectLocale from '@/components/lfs/Localiztion/SelectLocale.vue';
import TooltipSimple from "@/components/UI/TooltipSimple.vue";
import {checkContour} from "@/helpers/checkContour";

const auth = namespace("auth")
const profile = namespace("profile")
const app = namespace("app")
const event = namespace('event')
const roistat = namespace('roistat')


@Component({
  name:'Toolbar',
  components: {
    TooltipSimple,
    TestAlert,
    selectLocale
  }
})
export default class Toolbar extends Vue {
  @event.Getter('shows') protected shows:any
  @Prop({type: Boolean, default: false}) protected hideSearch!: boolean

  protected title: TranslateResult = ''


  @app.Mutation('SetShowSbToggle') protected SetShowSbToggle: any
  @app.Getter('GetShowSb') protected GetShowSb: any

  @auth.State("show") protected _show: any
  @auth.Action('logout') protected authLogout: any
  @profile.State("userCompany") protected userCompany: any
  @profile.Getter("plan") protected plan: any
  @event.Mutation('clear') protected clear: any
  @roistat.Action('sendEvent') protected sendEvent:any

  dropdownMenuState: boolean = false
  badgeTestState: boolean = false
  currentPlan:string = ''

  protected showSideBar() {
    alert('boom')
  }

  protected goProfile() {
    this.$router.push({name: 'Profile'}).catch(() => {
    })
    let params = [
      {
        "name": "Переход в “Профиль”",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }

  protected tryLogout() {
    this.$router.push({name: 'Logout'}).catch(()=>{})
  }

  @Watch('$route', {immediate: true})
  protected onRouteChange(route: Route) {
    switch (route.name) {
      case 'Standmans':
        this.title = 'toolbar.standmans'
        break
      case 'Profile':
        this.title = 'toolbar.profile'
        break

      case 'Products':
        this.title = 'toolbar.productList'
        break

      case 'ShardList':
        this.title = 'toolbar.shCommon'
        break

      case 'Statistics':
        this.title = 'toolbar.statistics'
        break

      case 'NewStatistics':
        this.title = 'toolbar.statistics'
        break

      case 'StatSurveys':
        this.title = 'toolbar.statistics'
        break

      case 'StatStandmans':
        this.title = 'toolbar.statistics'
        break

      case 'StatCollectedData':
        this.title = 'toolbar.statistics'
        break

      case 'Survey':
        this.title = 'toolbar.survey'
        break

      case 'Surveys':
        this.title = 'toolbar.surveys'
        break

      case 'SurveysDemo':
        this.title = 'toolbar.surveys'
        break


      case 'Support':
        this.title = 'toolbar.support'
        break

      case 'TestBadge':
        this.title = 'toolbar.testBadge'
        break

      case 'Testing':
        this.title = 'toolbar.testing'
        break

      case 'Localization':
        this.title = 'toolbar.localization'
        break

      case 'ContactBlock':
        this.title = 'toolbar.contacts'
        break

      default:
        this.title = ''
    }
  }

  created() {
    window.addEventListener('click', () => {
      this.dropdownMenuState = false
    })
    let response = checkContour('tariff', window.location.href)
    this.currentPlan = response == 'short' ? this.plan : 
           this.plan == 'pro' ? 'professional' : 
           this.plan == 'business' ? 'standard' : this.plan
    }
  }
